import errorCatcher from '@/shared/errors/globalErrorCatcher.js'
import '@/project/theme/theme.js'

import sendBugAlert from '@/shared/errors/sendBugAlert.js'
import setup from './setup.js'
import boot from './boot.js'

try {
  const { app, router } = setup()
  errorCatcher.setApp(app)
  router.isReady().then(() => {
    app.mount('#app')
    boot()
  })
} catch (error) {
  sendBugAlert(error)
  try {
    document.getElementById('crashScreen').style.display = 'flex'
  } catch (error) {}
  try {
    document.getElementById('rawSplash').style.display = 'none'
  } catch (error) {}
}
